import React from 'react';
import IconButton from '@mui/material/IconButton';
import ShareIcon from '@mui/icons-material/Share';

const HeaderSideComponent: React.FC = () => {
    const handleClick = () => {
        console.log('Share icon clicked');
    };

    return (
        <IconButton onClick={handleClick} sx={{ fontSize: 40 }}>
            <ShareIcon fontSize="large" />
        </IconButton>
    );
};

export default HeaderSideComponent;
